import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
      <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-100 mb-6">
        <i className="ri-emotion-sad-line text-4xl text-foreground-400"></i>
      </div>
      <h1 className="text-6xl font-heading font-bold text-foreground-300 mb-3">404</h1>
      <p className="text-xl font-heading font-semibold text-foreground-600 mb-2">页面未找到</p>
      <p className="text-sm text-foreground-500 mb-8 max-w-md">
        抱歉，您访问的页面不存在或已被移除。请检查链接是否正确，或返回首页浏览精彩内容。
      </p>
      <Link
        to="/"
        className="px-8 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200"
      >
        返回首页
      </Link>
    </div>
  );
}